/* SIFI BEAUVOIS — Product Navbar — apparition au scroll à la FIN du product hero
   (bas de la section passé sous le header — MAJ 26/07/2026, avant : au niveau du
   bouton CTA), navigation fluide (mini-produit + « Me prévenir ») et resynchro au
   switch de variante. */
(function () {
  'use strict';
  function headerHeight() {
    var h = document.querySelector('.sb-apple-header');
    if (!h || h.classList.contains('is-hidden')) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? r.bottom : 0;
  }
  function init() {
    var navRow = document.querySelector('.product-nav');
    if (!navRow || navRow.dataset.sbNavInit === '1') return;
    navRow.dataset.sbNavInit = '1';

    var ticking = false;

    /* MAJ 26/07 (demande Naji) : le repère d'apparition est la FIN du
       product hero — le bas de la section passe sous le header — et non
       plus le bouton CTA de la galerie. */
    function heroBottom() {
      var hero = document.querySelector('.sb-product-hero');
      if (!hero) return null;
      return hero.getBoundingClientRect().bottom;
    }

    function update() {
      ticking = false;
      navRow.style.setProperty('--pn-top', headerHeight() + 'px');
      var b = heroBottom();
      if (b === null) { navRow.classList.remove('is-visible', 'is-fixed'); return; }
      var show = b <= headerHeight() + 4;
      navRow.classList.toggle('is-visible', show);
      navRow.classList.toggle('is-fixed', show);
    }

    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('load', update);

    // Navigation fluide de la mini-information et du CTA « Me prévenir ».
    // L'écoute est déléguée à la navbar : elle reste active après un switch de cadran.
    function smoothTo(y, dur) {
      var startY = window.pageYOffset || document.documentElement.scrollTop;
      var targetY = Math.max(0, y);
      var duration = typeof dur === 'number' ? dur : 700;

      if (duration <= 0) {
        window.scrollTo(0, targetY);
        return;
      }

      var diff = targetY - startY;
      var t0 = performance.now();

      function ease(t) {
        return t < 0.5
          ? 4 * t * t * t
          : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function step(now) {
        var progress = Math.min((now - t0) / duration, 1);
        window.scrollTo(0, startY + diff * ease(progress));
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }

    navRow.addEventListener('click', function (e) {
      var clicked = e.target && e.target.closest ? e.target : null;
      if (!clicked) return;

      var newsletterLink = clicked.closest('.sb-pos-btn--scroll[href^="#"]');
      if (newsletterLink && navRow.contains(newsletterLink)) {
        var href = newsletterLink.getAttribute('href') || '';
        var targetId = href.slice(1);
        var target = targetId ? document.getElementById(targetId) : null;

        if (target) {
          e.preventDefault();

          var targetStyle = window.getComputedStyle(target);
          var scrollMarginTop = parseFloat(targetStyle.scrollMarginTop) || 0;
          var targetY = target.getBoundingClientRect().top
            + (window.pageYOffset || document.documentElement.scrollTop)
            - scrollMarginTop;
          var reducedMotion = window.matchMedia
            && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          smoothTo(targetY, reducedMotion ? 0 : 700);
        }
        return;
      }

      var mini = clicked.closest('.sb-product-mini');
      if (!mini || !navRow.contains(mini)) return;

      e.preventDefault();
      smoothTo(0, 700);
    });

    update();
  }
  // Synchro au switch de cadran (re-fetch de la section, comme les specs)
  function syncOnSwitch(variantId) {
    var wrapper = document.querySelector('[data-sb-product-navbar-wrapper]');
    if (!wrapper || !variantId) return;
    var sectionId = wrapper.getAttribute('data-section-id');
    var productUrl = wrapper.getAttribute('data-product-url');
    if (!sectionId || !productUrl) return;
    var url = productUrl + '?variant=' + encodeURIComponent(variantId) + '&section_id=' + encodeURIComponent(sectionId);
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-sb-product-navbar-wrapper]');
        if (fresh) wrapper.innerHTML = fresh.innerHTML;
        // Re-brancher le bouton d'achat sur le nouveau contenu
        if (window.sifiInitAddToCart) window.sifiInitAddToCart();
      })
      .catch(function () {});
  }
  document.addEventListener('sifi:variant-switched', function (e) {
    if (e.detail && e.detail.variantId) syncOnSwitch(e.detail.variantId);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();